import config from '@/config';
import { requests } from '.';
const LOCATION_SERVICE_URL = config === null || config === void 0 ? void 0 : config.LOCATION_SERVICE_URL;
const CALENDAR_SERVICE_URL = config === null || config === void 0 ? void 0 : config.CALENDAR_SERVICE_URL;
let recurringController;
let fetchSlotController;
let usersSlotController;
export const CalendarEventService = {
    getAll: (locationId) => requests(CALENDAR_SERVICE_URL).get(`/`, {
        params: {
            locationId,
        },
    }),
    getEvent: (id) => requests(LOCATION_SERVICE_URL).get(`/calendars/search/${id}`),
    getEventDetails: (id, timezone) => {
        const encodedTimezone = encodeURIComponent(timezone);
        return requests(CALENDAR_SERVICE_URL).get(`/events/appointments/${id}?timezone=${encodedTimezone}`);
    },
    getCalendarDetails: (id) => requests(CALENDAR_SERVICE_URL).get(`/${id}`),
    updateAppointment: (appointmentId, appointment) => requests(CALENDAR_SERVICE_URL).put(`/events/appointments/${appointmentId}`, appointment),
    deleteAppointment: (appointmentToBeEdited, data) => requests(CALENDAR_SERVICE_URL).delete(`/events/appointments/${appointmentToBeEdited}`, {
        data,
    }),
    getActivityLog: (params) => requests().get(`/logs/audit/search`, { params }),
    getFreeSlots: (calendarId, freeSlotQuery) => {
        if (fetchSlotController) {
            fetchSlotController.abort();
        }
        fetchSlotController = new AbortController();
        const signal = fetchSlotController.signal;
        return requests(CALENDAR_SERVICE_URL).get(`${calendarId}/free-slots`, {
            params: freeSlotQuery,
            signal,
        });
    },
    generateRRuleText: data => requests(CALENDAR_SERVICE_URL).post(`/generate-rrule-text`, data),
    getRecurringSlot: (selectedCalendarId, params) => {
        // Adding signal to cancel prev requests
        if (recurringController) {
            recurringController.abort();
        }
        recurringController = new AbortController();
        const signal = recurringController.signal;
        return requests(CALENDAR_SERVICE_URL).get(`/${selectedCalendarId}/recurring-slots`, {
            params,
            signal,
        });
    },
    blockSlot: data => requests(CALENDAR_SERVICE_URL).post(`/events/block-slots`, data),
    createAppointment: data => requests(CALENDAR_SERVICE_URL).post(`/events/appointments`, data),
    createRecurringEvents: (data, loggedInUserId) => requests(CALENDAR_SERVICE_URL).post(`/events/recurring-appointments`, data, { headers: { 'user-id': loggedInUserId } }),
    updateBlockSlot: (appointmentId, appointment) => requests(CALENDAR_SERVICE_URL).put(`/events/block-slots/${appointmentId}`, appointment),
    getCalendarEvents: (params) => requests(CALENDAR_SERVICE_URL).post('/events/get-calendar-events', params),
    getUserWiseFreeSlots: (calendarId, freeSlotQuery) => {
        if (usersSlotController) {
            usersSlotController.abort();
        }
        usersSlotController = new AbortController();
        const signal = usersSlotController.signal;
        return requests(CALENDAR_SERVICE_URL).get(`${calendarId}/users-free-slots`, {
            params: freeSlotQuery,
            signal,
        });
    },
};
